import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15997d94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "agent-action-folder-location" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "acfl--title gordita-400-12",
  style: {"margin-bottom":"8px"},
  "data-testid": "build-cache-folder-location-title"
}, " Cache Location ", -1))
const _hoisted_3 = { class: "acfl--error-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "acfl--title gordita-400-12",
  style: {"margin-bottom":"8px"},
  "data-testid": "build-cache-database-location-title"
}, " Database Location ", -1))
const _hoisted_5 = { class: "acfl--error-container" }
const _hoisted_6 = { "data-testid": "build-cache-database-location-input-error" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "acfl--note gordita-400-11",
  style: {"padding":"8px"},
  "data-testid": "build-cache-folder-location-note"
}, " NOTE: Any change to one folder location, requires updating the other location as well. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_incredi_text_input = _resolveComponent("incredi-text-input")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_action_menu_portal_container = _resolveComponent("action-menu-portal-container")!

  return (_openBlock(), _createBlock(_component_action_menu_portal_container, {
    style: {"max-width":"400px"},
    title: "Build Cache Folder Location",
    disable: !(Object.keys(_ctx.dirty) as Array<keyof typeof dirty>).some(key => _ctx.dirty[key]),
    "data-testid": _ctx.elementIds.agents.contextMenu.buildCacheConfiguration.folderLocation,
    onSubmit: _ctx.onSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_form, { ref: "acfl--form" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _hoisted_2,
              _createVNode(_component_incredi_text_input, {
                ref: "cacheFolderInput",
                "data-testid": "build-cache-folder-location-input",
                maxlength: "260",
                "to-be-clearable": false,
                "no-error-icon": "",
                "model-value": _ctx.cacheFolder,
                rules: [
              _ctx.validatePath,
              (val) => {
                return !(!_ctx.dirty.cacheFolder && _ctx.dirty.databaseFolder) || 'Path change required';
              },
            ],
                "onUpdate:modelValue": _cache[0] || (_cache[0] = 
              (val) => {
                _ctx.cacheFolder = val;
                _ctx.dirty.cacheFolder = val !== _ctx.buildCacheSettings?.cacheFolder;
              }
            ),
                onBlur: _cache[1] || (_cache[1] = () => (_ctx.$refs.databaseFolderInput as any).validate())
              }, {
                error: _withCtx((errorMessage) => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_q_icon, { name: "icon-Error_notification_filled" }),
                    _createElementVNode("span", null, _toDisplayString(errorMessage), 1)
                  ])
                ]),
                _: 1
              }, 8, ["model-value", "rules"])
            ]),
            _createElementVNode("div", null, [
              _hoisted_4,
              _createVNode(_component_incredi_text_input, {
                ref: "databaseFolderInput",
                maxlength: "260",
                "data-testid": "build-cache-database-location-input",
                "to-be-clearable": false,
                "model-value": _ctx.databaseFolder,
                rules: [
              _ctx.validatePath,
              ,
              () => {
                return !(!_ctx.dirty.databaseFolder && _ctx.dirty.cacheFolder) || 'Path change required';
              },
            ],
                "no-error-icon": "",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = 
              (val) => {
                _ctx.databaseFolder = val;
                _ctx.dirty.databaseFolder = val !== _ctx.buildCacheSettings?.databaseFolder;
              }
            ),
                onBlur: _cache[3] || (_cache[3] = () => (_ctx.$refs.cacheFolderInput as any).validate())
              }, {
                error: _withCtx((errorMessage) => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_q_icon, { name: "icon-Error_notification_filled" }),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(errorMessage), 1)
                  ])
                ]),
                _: 1
              }, 8, ["model-value", "rules"])
            ]),
            _hoisted_7
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["disable", "data-testid", "onSubmit"]))
}